import { ComponentProps } from "react";

export default function StarIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.54009 16H8.39009C7.94365 12.2544 6.90082 9.80419 4.96509 8.0335V7.9665C6.90082 6.19581 7.94365 3.74556 8.39009 0H8.54009C8.98652 3.74556 10.0294 6.19581 11.9651 7.9665V8.0335C10.0294 9.80419 8.98652 12.2544 8.54009 16Z"
        fill="currentColor"
      />
    </svg>
  );
}
